<template>
  <b-alert v-if="hasErrorServices" show fade variant="danger" style="margin: unset; border-radius: unset" class="d-flex align-items-center justify-content-between ">
    <strong>
      <span>{{ $t('number-of-errors') | capitalize }} </span>
      <b-badge variant="danger">{{ errorServicesCount }}</b-badge>
    </strong>
    <b-button
      variant="danger"
      :to="{ name: 'error-services' }">
      {{ $t('show') }}
    </b-button>
  </b-alert>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AlertBar',
  computed: {
    ...mapGetters([
      'getErrorServices',
    ]),
    errorServicesCount() {
      return this.getErrorServices.length;
    },
    hasErrorServices() {
      return this.errorServicesCount > 0;
    },
  },
};
</script>

<style scoped></style>
